import React from "react";
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Row, CardHeader, CardGroup, CardDeck } from 'reactstrap'
import { GST, EPF, LEGAL, RATING, MCA,EXTERNAL_CREDIT_RATING, CRAWLER_COM_SCORE_GREATER_THAN_75, EXTERNAL_RATING_SCORE_GREATER_THAN_75, MORE_THAN_75, NOT_APPLICABLE_OR_AVAILABLE, GREATER_THAN_OR_EQUAL_TO_50, LESS_THAN_50, _NA, _1_TO_7_DAYS, _8_TO_15_DAYS, _NO_DELAY, _16_TO_30_DAYS, _31_TO_60_DAYS, _MORE_THAN_90_DAYS, _61_TO_90_DAYS,NCLT_NOTE_FOR_LEGAL,SEBI_DEFAULTER_NOTE_FOR_LEGAL,RBI_WILLFUL_DEFAULTER_NOTE_FOR_LEGAL,RBI_SUIT_FILED_NOTE_FOR_LEGAL,SCORE_NOTE_FOR_LEGAL,SHORT_TERM_STATUS_NOTE_FOR_RATING,LONG_TERM_STATUS_NOTE_FOR_RATING,SHORT_TERM_NOTE_FOR_RATING,LONG_TERM_NOTE_FOR_RATING,SCORE_NOTE_FOR_RATING,BALANCE_SHEET_NOTE_FOR_MCA,COMPANY_COMPLIANCE_NOTE_FOR_MCA,COMPANY_STATUS_NOTE_FOR_MCA,SCORE_NOTE_FOR_MCA,CURRENT_DELAY_NOTE_FOR_EPF,SCORE_NOTE_FOR_EPF,AVERAGE_DELAY_NOTE_FOR_EPF,CURRENT_DELAY_NOTE_FOR_GST,SCORE_NOTE_FOR_GST,AVERAGE_DELAY_NOTE_FOR_GST, NOT_APPLICABLE} from '../../constants';
import { connect } from 'react-redux';
import { Preloading as preloading } from '../../../../components/UI/Preloader/action';
import { fetchMonitoringListRequest, fetchCorporateMonitoringRequest, downloadCorporateMonitoringReportRequest } from "../action"
import Select from 'react-select'
import MonitoringPieChart from "./monitoring-pie-chart";
import MonitoringBarChart from "./monitoring-bar-chart";
import fileSaver from 'file-saver';
import moment from 'moment';
import { toast } from 'react-toastify';
import {
    crawlerDataOptions, prepareLegalGraphData, prepareLegalData, prepareCompanyBalanceSheetDateGraphData, 
    prepareCompanyBalanceSheetDateData, getScoreFromObj, prepareDelayData, prepareScoreData, prepareComapnyComplianceData, 
    prepareCompanyComplianceGraphData, prepareCompanyStatusGraphData, prepareCompanyStatusData, prepareDelayGraphData, 
    prepareLongTermRatingData, prepareGraphData, prepareStatusData,prepareRatingData,prepareRatingGraphData
} from "./monitoring-util";

import { getUserInfo } from "../../../../helper";
import MonitoringPieChartEPFGST from "./monitoring-pie-chart-gst-epf";
import MonitoringScorePieChart from "./monitoring-score-pie-chart";
import MonitoringStatusPieChart from "./monitoring-mca-pie-chart";
import MonitoringLegalPieChart from "./monitoring-legal-pie-chart";
import MonitoringRatingStatusPieChart from "./monitoring-rating-status-pie-chart";
import MonitoringCommplaincesPieChart from "./monitoring-mca-compliance-pie-chart";

export const scoreData1 = Object.freeze({ "GREATER_THAN_OR_EQUAL_TO_50": 0, "LESS_THAN_50": 0, "CRAWLER_COM_SCORE_GREATER_THAN_75": 0, "NOT_APPLICABLE_OR_AVAILABLE": 0 });
export const avgDelayData1 = Object.freeze({ "_0_TO_7_DAYS": 0, "_8_TO_15_DAYS": 0, "_16_TO_30_DAYS": 0, "_31_TO_60_DAYS": 0, "_61_TO_90_DAYS": 0, "_MORE_THAN_90_DAYS": 0, "_NO_DELAY": 0, "_NA": 0 });
export const currentDelayData1 = Object.freeze({ "_0_TO_7_DAYS": 0, "_8_TO_15_DAYS": 0, "_16_TO_30_DAYS": 0, "_31_TO_60_DAYS": 0, "_61_TO_90_DAYS": 0, "_MORE_THAN_90_DAYS": 0, "_NO_DELAY": 0, "_NA": 0 });
export const companyStatusData1 = Object.freeze({  "NOT_APPLICABLE": 0,"COMPANY_STATUS_ACTIVE": 0 , "COMPANY_STATUS_INACTIVE": 0 ,"DORMANT" : 0 ,"DORMANT_UNDER_SECTION_455": 0, "ACTIVE_IN_PROGRESS" : 0, "AMALGAMATED" : 0, "NOT_AVAILABLE_FOR_EFILING" : 0, "CONVERTED_TO_LLP" : 0, "CONVERTED_TO_LLP_DISSOLVED" : 0, "DISSOLVED" : 0, "UNDER_LIQUIDATION" : 0, "LIQUIDATED": 0 ,"UNDER_PROCESS_OF_STRIKING_OFF": 0 ,"STRIKE_OFF" : 0, "CAPTURED" : 0});
export const comapnyComplianceData1 = Object.freeze({ "COMPANY_COMPLIANCE_ACTIVE": 0, "COMPANY_COMPLIANCE_INACTIVE": 0, "_NA": 0 });
export const legalData1 = Object.freeze({ "No": 0, "Yes": 0 });
export const longTermRating1 = Object.freeze ({ "AAA" : 0, "AA" : 0, "A" : 0, "BBB" : 0, "BB" : 0, "B" : 0, "C" : 0, "D" : 0, "Issuer Not Cooperating" : 0, "Not Applicable" : 0})
export const shortTermRating1 = Object.freeze({ "A1" : 0, "A2" : 0, "A3" : 0, "A4" : 0, "D" : 0, "Issuer Not Cooperating" : 0, "Not Applicable" : 0})
export const ratingStatusData1 = Object.freeze({ "NOT_RATED": 0, "NA": 0 ,  "DOWNGRADED": 0  ,"ISSUER_NOT_COOPERATING":0 ,"NEWLY_RATED":0 , "UPGRADED": 0 , "NO_CHANGE": 0});
export const scoreLegendGST="GST Compliance Score ";
export const scoreLegendEPF="EPF Compliance Score ";
export const scoreLegendMCA="MCA Compliance Score";
export const scoreLegendRating="External Credit Rating Score ";
export const scoreLegendLegal="Legal Compliance Score";
class MonitoringChart extends React.Component {

    state = {
        monitoringMetaData: [], monitoringSelectedOption: undefined, crawlerSelectedOption: { value: GST, label: "GST" }, crawlerDataOptions: [],
        scoreData: {}, scoreGraphData: [], avgDelayData: {}, avgDelayGraphData: [], currentDelayData: {}, currentDelayGraphData: {},
        companyStatusData: {}, companyStatusGraphData: [], comapnyComplianceData: {}, comapnyComplianceGraphData: [],
        companyBalanceSheetDateData: {}, companyBalanceSheetDateGraphData: [], legalSuitFiledData: {}, legalSuitFiledGraphData: [],
        legalWilfulDefaulterData: {}, legalWilfulDefaulterGraphData: [], legalSebiDefaulterData: {}, legalSebiDefaulterGraphData: [],
        legalNcltData: {}, legalNcltGraphData: [], longTermData : {}, longTermGraphData : [], shortTermRating : {}, shortTermRatingGraphData : [],
        shortTermStatus : {},shortTermStatusGraphData : [], longTermStatus : {}, longTermStatusGraphData : [],
        userData : {},SCORE_NOTE:undefined,AVERAGE_DELAY_NOTE:undefined,CURRENT_DELAY_NOTE:undefined,SCORE_LEGEND:undefined,CurrentAverageLegend:undefined
    }

    prepareScoreGraphData = (crawler) => {
        switch (crawler) {
            case LEGAL: crawler = 'Legal'; break;
            case RATING: crawler = EXTERNAL_CREDIT_RATING; break;
        }
        let scoreData = [];
        if (crawler == EXTERNAL_CREDIT_RATING){
            scoreData = [['Range of Score', 'Score'], [crawler + EXTERNAL_RATING_SCORE_GREATER_THAN_75, this.state.scoreData[crawler + "EXTERNAL_RATING_SCORE_GREATER_THAN_75"]],
            [GREATER_THAN_OR_EQUAL_TO_50, this.state.scoreData["GREATER_THAN_OR_EQUAL_TO_50"]], [LESS_THAN_50, this.state.scoreData["LESS_THAN_50"]],
            [NOT_APPLICABLE, this.state.scoreData["NOT_APPLICABLE_OR_AVAILABLE"]]];
        } else {
            scoreData = [['Range of Score', 'Score'], [crawler + CRAWLER_COM_SCORE_GREATER_THAN_75, this.state.scoreData[crawler + "CRAWLER_COM_SCORE_GREATER_THAN_75"]],
            [GREATER_THAN_OR_EQUAL_TO_50, this.state.scoreData["GREATER_THAN_OR_EQUAL_TO_50"]], [LESS_THAN_50, this.state.scoreData["LESS_THAN_50"]],
            [NOT_APPLICABLE, this.state.scoreData["NOT_APPLICABLE_OR_AVAILABLE"]]];
        }
        this.setState({ scoreGraphData: scoreData })
    }

    normalizeGraphData = () => {
        this.prepareScoreGraphData(this.state.crawlerSelectedOption.value);
        if (this.state.crawlerSelectedOption && (this.state.crawlerSelectedOption.value === GST || this.state.crawlerSelectedOption.value === EPF)) {
            let avgDelayData = prepareDelayGraphData('Average Delay Days', this.state.avgDelayData);
            let currentDelayData = prepareDelayGraphData('Current Delay Days', this.state.currentDelayData);
            if(this.state.crawlerSelectedOption.value === EPF){
                this.setState({ SCORE_NOTE: SCORE_NOTE_FOR_EPF , AVERAGE_DELAY_NOTE : AVERAGE_DELAY_NOTE_FOR_EPF , CURRENT_DELAY_NOTE : CURRENT_DELAY_NOTE_FOR_EPF ,SCORE_LEGEND:scoreLegendEPF,CurrentAverageLegend:this.state.crawlerSelectedOption});
            }
            else{
                this.setState({ SCORE_NOTE: SCORE_NOTE_FOR_GST , AVERAGE_DELAY_NOTE : AVERAGE_DELAY_NOTE_FOR_GST , CURRENT_DELAY_NOTE : CURRENT_DELAY_NOTE_FOR_GST ,SCORE_LEGEND:scoreLegendGST,CurrentAverageLegend:this.state.crawlerSelectedOption});
            }
            
            this.setState({ avgDelayGraphData: avgDelayData, currentDelayGraphData: currentDelayData });
        } else if (this.state.crawlerSelectedOption && this.state.crawlerSelectedOption.value === MCA) {
            let companyStatusGraphData = prepareCompanyStatusGraphData("Company Status", this.state.companyStatusData);
            let comapnyComplianceGraphData = prepareCompanyComplianceGraphData("Compliance", this.state.comapnyComplianceData);
            let companyBalanceSheetDateGraphData = prepareCompanyBalanceSheetDateGraphData("Balance Sheet", this.state.companyBalanceSheetDateData);
            this.setState({ companyStatusGraphData: companyStatusGraphData, comapnyComplianceGraphData: comapnyComplianceGraphData, companyBalanceSheetDateGraphData: companyBalanceSheetDateGraphData,SCORE_NOTE: SCORE_NOTE_FOR_MCA ,SCORE_LEGEND:scoreLegendMCA});
        } else if (this.state.crawlerSelectedOption && this.state.crawlerSelectedOption.value === LEGAL) {
            let legalNcltGraphData = prepareLegalGraphData("NCLT", this.state.legalNcltData);
            let legalSebiDefaulterGraphData = prepareLegalGraphData("Sebi Defaulter", this.state.legalSebiDefaulterData);
            let legalSuitFiledGraphData = prepareLegalGraphData("RBI Suite Filed", this.state.legalSuitFiledData);
            let legalWilfulDefaulterGraphData = prepareLegalGraphData("RBI Wilful Defaulter", this.state.legalWilfulDefaulterData);
            this.setState({
                legalNcltGraphData: legalNcltGraphData, legalSebiDefaulterGraphData: legalSebiDefaulterGraphData,
                legalSuitFiledGraphData: legalSuitFiledGraphData, legalWilfulDefaulterGraphData: legalWilfulDefaulterGraphData,
                SCORE_NOTE: SCORE_NOTE_FOR_LEGAL,SCORE_LEGEND:scoreLegendLegal
            })
        }else if (this.state.crawlerSelectedOption && this.state.crawlerSelectedOption.value === RATING) {
                let longTermGraphData = prepareGraphData(this.state.longTermData, "") 
                let shortTermRatingGraphData = prepareGraphData(this.state.shortTermRating, "");
                let longTermStatusGraphData = prepareRatingGraphData( "Long Term Status",this.state.longTermStatus);
                let shortTermStatusGraphData = prepareRatingGraphData( "Short Term Status",this.state.shortTermStatus);
               this.setState({ longTermGraphData : longTermGraphData, shortTermRatingGraphData : shortTermRatingGraphData,
                longTermStatusGraphData : longTermStatusGraphData, shortTermStatusGraphData : shortTermStatusGraphData,
                SCORE_NOTE: SCORE_NOTE_FOR_RATING,SCORE_LEGEND:scoreLegendRating})
        }
        
    }

    prepareGraphData = () => {
        let scoreData = { ...scoreData1 };
        switch(this.state.crawlerSelectedOption.value) {
            case GST: scoreData[GST + 'CRAWLER_COM_SCORE_GREATER_THAN_75'] = scoreData['CRAWLER_COM_SCORE_GREATER_THAN_75']; break;
            case MCA: scoreData[MCA + 'CRAWLER_COM_SCORE_GREATER_THAN_75'] = scoreData['CRAWLER_COM_SCORE_GREATER_THAN_75']; break;
            case EPF: scoreData[EPF + 'CRAWLER_COM_SCORE_GREATER_THAN_75'] = scoreData['CRAWLER_COM_SCORE_GREATER_THAN_75']; break;
            case LEGAL: scoreData['Legal' + 'CRAWLER_COM_SCORE_GREATER_THAN_75'] = scoreData['CRAWLER_COM_SCORE_GREATER_THAN_75']; break;
            case RATING: scoreData[EXTERNAL_CREDIT_RATING + 'EXTERNAL_RATING_SCORE_GREATER_THAN_75'] = scoreData['CRAWLER_COM_SCORE_GREATER_THAN_75']; break;
        }
        let companyStatusData = { ...companyStatusData1 };
        let avgDelayData = { ...avgDelayData1 };
        let currentDelayData = { ...currentDelayData1 };
        let comapnyComplianceData = { ...comapnyComplianceData1 };
        let companyBalanceSheetDateData = { "NA": 0 };
        let legalSebiDefaulterData = { ...legalData1 };
        let legalSuitFiledData = { ...legalData1 };
        let legalWilfulDefaulterData = { ...legalData1 };
        let legalNcltData = { ...legalData1 };
        let longTermData = { ...longTermRating1};
        let shortTermRating = { ...shortTermRating1}
        let shortTermStatus = { ...ratingStatusData1};
        let longTermStatus = { ...ratingStatusData1};
        if (this.props.corporateMonitoringData && this.props.corporateMonitoringData.length > 0) {
            this.props.corporateMonitoringData.map(obj => {
                let score = getScoreFromObj(obj, this.state.crawlerSelectedOption.value);
                scoreData = prepareScoreData(scoreData, score, this.state.crawlerSelectedOption.value);
                if (this.state.crawlerSelectedOption && (this.state.crawlerSelectedOption.value === GST || this.state.crawlerSelectedOption.value === EPF)) {
                    return (avgDelayData = prepareDelayData(avgDelayData, obj.avgDelay), 
                    currentDelayData = prepareDelayData(currentDelayData, obj.currentDelay))
                } else if (this.state.crawlerSelectedOption && this.state.crawlerSelectedOption.value === MCA) {
                    return (companyStatusData = prepareCompanyStatusData(companyStatusData, obj.companyStatus),
                    comapnyComplianceData = prepareComapnyComplianceData(comapnyComplianceData, obj.activeCompliance),
                    companyBalanceSheetDateData = prepareCompanyBalanceSheetDateData(companyBalanceSheetDateData, obj.yearOfLatestBalanceSheet))
                } else if (this.state.crawlerSelectedOption && this.state.crawlerSelectedOption.value === LEGAL) {
                    return (legalSebiDefaulterData = prepareLegalData(legalSebiDefaulterData, obj.sebiDefaulter),
                    legalSuitFiledData = prepareLegalData(legalSuitFiledData, obj.rbiDefaulter),
                    legalWilfulDefaulterData = prepareLegalData(legalWilfulDefaulterData, obj.rbiWilfulDefaulter),
                    legalNcltData = prepareLegalData(legalNcltData, obj.nclt))
                }else if(this.state.crawlerSelectedOption && this.state.crawlerSelectedOption.value === RATING){
                   return (longTermData = prepareLongTermRatingData(longTermData, obj.longTermCurrentRating),
                    shortTermRating =  prepareLongTermRatingData(shortTermRating, obj.shortTermCurrentRating),
                    shortTermStatus = prepareRatingData(shortTermStatus, obj.shortTermStatus),
                    longTermStatus = prepareRatingData(longTermStatus, obj.longTermStatus))
                }
                    return;
                
            })
            this.setState({
                scoreData: scoreData, avgDelayData: avgDelayData, currentDelayData: currentDelayData,
                companyStatusData: companyStatusData, comapnyComplianceData: comapnyComplianceData, companyBalanceSheetDateData: companyBalanceSheetDateData,
                legalSuitFiledData: legalSuitFiledData, legalWilfulDefaulterData: legalWilfulDefaulterData,
                legalSebiDefaulterData: legalSebiDefaulterData, legalNcltData: legalNcltData,
                longTermData : longTermData, shortTermRating : shortTermRating, shortTermStatus : shortTermStatus,longTermStatus :longTermStatus 
            }, () => {
                this.normalizeGraphData();
            })
        }
    }

    fetchCorporateMonitoringData = (e) => {
        e.preventDefault();
        if (this.state.monitoringSelectedOption && this.state.monitoringSelectedOption.value) {
            this.props.preloading(true);
            this.props.fetchCorporateMonitoringRequest({ monitoringId: this.state.monitoringSelectedOption.value, type: this.state.crawlerSelectedOption.value });
        }
    }

    componentDidMount() {
        let data = getUserInfo();
        this.setState({ userData  : data }, ()=> {
            this.props.fetchMonitoringListRequest({corporateId : this.state.userData ? this.state.userData.corporateId : undefined})
        });
        this.props.preloading(true);
        this.setState({ crawlerDataOptions: crawlerDataOptions });
    }

    handleMonitoringChange = (option) => {
        this.setState({ monitoringSelectedOption: option })
    }

    handleCrawlerChange = (option) => {
        this.setState({ crawlerSelectedOption: option })
    }

    componentDidUpdate(prevProps) {
        if (this.props.monitoringList !== prevProps.monitoringList) {
            this.props.preloading(false);
            let monitoringNameOptions = [];
            this.props.monitoringList && this.props.monitoringList.length > 0 &&
                this.props.monitoringList.map(monitoringObj => {
                    return monitoringNameOptions = [
                        ...monitoringNameOptions, {
                            value: monitoringObj.id, label: monitoringObj.monitoringName
                        }
                    ]
                })
            this.setState({ monitoringMetaData: monitoringNameOptions, monitoringSelectedOption: monitoringNameOptions.length > 0 ? monitoringNameOptions[0] : undefined }, () => {
                if (this.state.monitoringSelectedOption && this.state.monitoringSelectedOption.value) {
                    this.props.preloading(true);
                    this.props.fetchCorporateMonitoringRequest({ monitoringId: this.state.monitoringSelectedOption.value, type: this.state.crawlerSelectedOption.value });
                }
            })
        }
        if (prevProps.corporateMonitoringData !== this.props.corporateMonitoringData) {
            this.props.preloading(false);
            this.setState({
                avgDelayData: {}, currentDelayData: {}, scoreData: {}, companyStatusData: {},
                companyStatusGraphData: {}, companyBalanceSheetDateData: {}, legalSebiDefaulterData: {}, legalSuitFiledData: {},
                legalNcltData: {}, legalWilfulDefaulterData: {}, longTermData : {}, shortTermRating :{}, shortTermStatus : {}, 
                longTermStatus : {},scoreGraphData: [], avgDelayGraphData: [], currentDelayGraphData: [],
                companyStatusGraphData: [], comapnyComplianceGraphData: [], companyBalanceSheetDateGraphData: [],
                legalWilfulDefaulterGraphData: [], legalNcltGraphData: [], legalSuitFiledGraphData: [], legalSebiDefaulterGraphData: [],
                longTermGraphData : [], shortTermRatingGraphData :[], shortTermStatusGraphData :[], longTermStatusGraphData :[]
            });
            this.prepareGraphData();
        }

        if (this.props.corporateMonitoringReport !== prevProps.corporateMonitoringReport) {
            this.props.preloading(false);
            if (this.props.corporateMonitoringReport.status === "SUCCESS") {
                const data = this.props.corporateMonitoringReport.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"monitoring_report"}_${this.state.monitoringSelectedOption.label}_${moment().format("DD_MMM_YYYY")}.xlsx`)
            } else if (this.props.corporateMonitoringReport.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }
    }

    downloadMonitoringReport = (e) => {
        e.preventDefault();
        this.props.preloading(true);
       this.props.downloadCorporateMonitoringReportRequest({monitoringId : this.state.monitoringSelectedOption.value, corporateId : this.state.userData.corporateId});
    }

    render() {
        return (
            <Col>
                { this.state.monitoringMetaData && this.state.monitoringMetaData.length > 0 ? <div>
                    <Card>
                    <CardBody >
                        <Form className="w-100" >
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={4}>Monitoring Name </Label>
                                <Col sm={6}>
                                    <Select
                                        value={this.state.monitoringSelectedOption}
                                        onChange={this.handleMonitoringChange}
                                        options={this.state.monitoringMetaData} />
                                </Col>
                                <Col style={{ marginLeft: "1rem" }} sm={6}>
                                    <Select
                                        value={this.state.crawlerSelectedOption}
                                        onChange={this.handleCrawlerChange}
                                        options={this.state.crawlerDataOptions} />
                                </Col>
                                <Col style={{ marginLeft: "1rem" }} sm={3}>
                                    <Button color="primary" disabled={!this.state.monitoringSelectedOption} onClick={(e) => this.fetchCorporateMonitoringData(e)}>Show Graph</Button>
                                </Col>

                                <Col style={{ marginLeft: "1rem" }} sm={3}>
                                <Button color='primary' onClick={(e) => this.downloadMonitoringReport(e)}>{this.state.monitoringSelectedOption ? this.state.monitoringSelectedOption.label :""} &nbsp;&nbsp;<i className="fa fa-download"></i></Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                    </Card>
                    <br></br>
                    <CardGroup style={{justifyContent: 'center'}}>
                    {this.state.scoreGraphData && this.state.scoreGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringScorePieChart data={this.state.scoreGraphData} title={this.state.SCORE_LEGEND} />
                            <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:this.state.SCORE_NOTE}}></p>
                            </details>
                        </Card>}

                        {this.state.avgDelayGraphData && this.state.avgDelayGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringPieChartEPFGST data={this.state.avgDelayGraphData} title={'Average Days of Delay in filing '+this.state.CurrentAverageLegend.value+' Returns'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:this.state.AVERAGE_DELAY_NOTE}}></p>
                            </details>
                        </Card>}
                        {this.state.currentDelayGraphData && this.state.currentDelayGraphData.length > 0 && <Card  style={{minWidth: '500px', minHeight:'300px'}}><MonitoringPieChartEPFGST data={this.state.currentDelayGraphData} title={'Current Days of Delay in filing '+this.state.CurrentAverageLegend.value+' Returns'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:this.state.CURRENT_DELAY_NOTE}}></p>
                            </details>
                        </Card>}

                        {this.state.companyStatusGraphData && this.state.companyStatusGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringStatusPieChart data={this.state.companyStatusGraphData} title={'Company Status'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:COMPANY_STATUS_NOTE_FOR_MCA}}></p>
                            </details>
                        </Card>}
                        {this.state.comapnyComplianceGraphData && this.state.comapnyComplianceGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringCommplaincesPieChart data={this.state.comapnyComplianceGraphData} title={'MCA Compliance'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:COMPANY_COMPLIANCE_NOTE_FOR_MCA}}></p>
                            </details>
                        </Card>}
                        {this.state.companyBalanceSheetDateGraphData && this.state.companyBalanceSheetDateGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringBarChart data={this.state.companyBalanceSheetDateGraphData} title={'Latest Year of Financial Statements'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:BALANCE_SHEET_NOTE_FOR_MCA}}></p>
                            </details>
                        </Card>}

                        {this.state.legalSuitFiledGraphData && this.state.legalSuitFiledGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringLegalPieChart data={this.state.legalSuitFiledGraphData} title={'RBI Suit Filed Cases'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:RBI_SUIT_FILED_NOTE_FOR_LEGAL}}></p>
                            </details>
                        </Card>}
                        {this.state.legalWilfulDefaulterGraphData && this.state.legalWilfulDefaulterGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringLegalPieChart data={this.state.legalWilfulDefaulterGraphData} title={'RBI Wilful Defaulters List'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:RBI_WILLFUL_DEFAULTER_NOTE_FOR_LEGAL}}></p>
                            </details>
                        </Card>}
                        {this.state.legalSebiDefaulterGraphData && this.state.legalSebiDefaulterGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringLegalPieChart data={this.state.legalSebiDefaulterGraphData} title={'SEBI Defaulters List'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:SEBI_DEFAULTER_NOTE_FOR_LEGAL}}></p>
                            </details>
                        </Card>}
                        {this.state.legalNcltGraphData && this.state.legalNcltGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringLegalPieChart data={this.state.legalNcltGraphData} title={'NCLT Filings'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:NCLT_NOTE_FOR_LEGAL}}></p>
                            </details>
                        </Card>}

                        {this.state.longTermGraphData && this.state.longTermGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringBarChart data={this.state.longTermGraphData} title={'Distribution of Long-Term External Credit Ratings'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:LONG_TERM_NOTE_FOR_RATING}}></p>
                            </details>
                        </Card>}
                        {this.state.shortTermRatingGraphData && this.state.shortTermRatingGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringBarChart data={this.state.shortTermRatingGraphData} title={'Distribution of Short-Term External Credit Ratings'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:SHORT_TERM_NOTE_FOR_RATING}}></p>
                            </details>
                        </Card>}
                        {this.state.longTermStatusGraphData && this.state.longTermStatusGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringRatingStatusPieChart data={this.state.longTermStatusGraphData} title={'Change in Long-Term External Credit Ratings'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:LONG_TERM_STATUS_NOTE_FOR_RATING}}></p>
                            </details>
                        </Card>}
                        {this.state.shortTermStatusGraphData && this.state.shortTermStatusGraphData.length > 0 && <Card style={{minWidth: '500px', minHeight:'300px'}}><MonitoringRatingStatusPieChart data={this.state.shortTermStatusGraphData} title={'Change in Short-Term External Credit Ratings'} />
                        <details>
                                <summary>
                                    <i>Know more...</i>
                                </summary>
                                <p dangerouslySetInnerHTML={{ __html:SHORT_TERM_STATUS_NOTE_FOR_RATING}}></p>
                            </details>
                        </Card>}
                    </CardGroup>
                </div> : 
                    <Card>
                        <CardBody className="text-center" > Monitoring Not Available ! </CardBody>
                    </Card>}
            </Col>
        )
    }
}


const mapStateToProps = (state) => ({
    monitoringList: state.monitoringData.monitoringList,
    corporateMonitoringData: state.monitoringData.corporateMonitoringData,
    corporateMonitoringReport: state.monitoringData.corporateMonitoringReport
})

const mapDispatchToProps = (dispatch) => ({
    preloading: data => { dispatch(preloading(data)) },
    fetchMonitoringListRequest: data => { dispatch(fetchMonitoringListRequest(data)) },
    fetchCorporateMonitoringRequest: data => { dispatch(fetchCorporateMonitoringRequest(data)) },
    downloadCorporateMonitoringReportRequest : data => { dispatch(downloadCorporateMonitoringReportRequest(data))}
});
export default connect(mapStateToProps, mapDispatchToProps)(MonitoringChart);